export const getImagesByGroup = images => {
  return Object.entries(images).reduce((acc, [key, image]) => {
    const groupKey = image?.group

    if (!acc[groupKey]) {
      acc[groupKey] = {}
    }

    acc[groupKey][key] = image

    return acc
  }, {})
}
